<template>
  <div class="container general-section">

    <div class="pb-4">
      <h1>
        <font-awesome-icon icon="receipt" />
        Fakturor
      </h1>

      <invoices />
    </div>


    <h1>
      <font-awesome-icon icon="coins"/>
      Nuvarande ersättning
    </h1>

    <div v-if="loaded">

      <div class="alert alert-info" v-if="total_cost">
        <small>
          Total ersättning: <b>{{ total_cost }} kr.</b>
        </small>
      </div>

      <div>
        <search-earnings v-if="affiliate.earnings_mode === 'search' || affiliate.earnings_mode === 'mixed'" :earnings="searchEarnings" />

        <order-earnings v-if="affiliate.earnings_mode === 'order' || affiliate.earnings_mode === 'mixed'" :earnings="orderEarnings" />
      </div>

      <pagination :pagination="pagination" :next="next"></pagination>
    </div>

    <contents-loader text="Laddar ersättning..." v-else />

  </div>
</template>

<script>

  import {createNamespacedHelpers, mapState} from "vuex"
  import Pagination from "../../Partials/Pagination"
  import SearchEarnings from "./Partials/Search"
  import ContentsLoader from "../../Partials/Loader/Contents"
  import OrderEarnings from "./Partials/Order"
  import Invoices from "./Partials/Invoices"

  const { mapState: msEarnings } = createNamespacedHelpers('earnings')

  export default {
    name: "Earnings",
    components: {Invoices, OrderEarnings, ContentsLoader, SearchEarnings, Pagination},
    computed: {
      ...msEarnings({
        loaded: state => state.loaded,
        earnings: state => state.collection,
        pagination: state => state.pagination,
        total_cost: state => state.total_cost,
      }),
      ...mapState({
        affiliate: state => state.auth.affiliate
      }),
      searchEarnings() {
        return this.earnings.filter(earning => earning.earnings_mode === 'search')
      },
      orderEarnings() {
        return this.earnings.filter(earning => earning.earnings_mode === 'order')
      }
    },
    mounted() {
      return this.get()
    },
    destroyed(){
      this.$store.commit('earnings/truncate')
    },
    methods: {
      get(page = 1){
        let input = {
          page,
          filter: {
            invoice_uuid: null
          }
        }

        return this.$store.dispatch('earnings/fetch', input)
      },
      next() {
        return this.get(this.pagination.current_page + 1)
      },
    },
    metaInfo() {
      return {
        title: 'Ersättning och fakturor'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Dashboard/Earnings/Index.vue